import {
  createMasterEvent,
  createMasterFloor,
  getSingleMasterFloor,
  updateMasterFloor,
} from "_services";
import { getGuest } from "_services/guestServices";
import {
  CommonDate,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
} from "components";
import { createEvent } from "features/masterService";
import { errorSchema, utils } from "helper";
import React, { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const AddFloorModal = (props) => {
  const [form, setForm] = useState({
    name: "",
    supervisor:""
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nameRef = useRef();
  const startRef = useRef();
  const endRef = useRef();
  
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [supervisorList,setSupervisorList] = useState([])
   const [filter, setFilter] = useState({
      user_type:4
    });

  useEffect(() => {
    if (props?.addressId) {
      getFloorDetails(props?.addressId);
     
    }
  }, [props?.addressId]);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
      getSuperVisorList()
    }
  }, []);



  const getFloorDetails = async (id) => {
    try {
      const res = await getSingleMasterFloor(id);

      if (res?.status === 200) {
        setForm({
          ...form,
          name: res?.results?.name,
          supervisor:res?.results?.supervisor
        });
      }
    } catch (error) {}
  };


  const getSuperVisorList = async (url = null) => {
    try {
     
      const filterParams = new URLSearchParams();

      Object.keys(filter).forEach(key => {
        if (filter[key]) {
          filterParams.append(key, filter[key]);
        }
      });

      const res = await getGuest(url,filterParams.toString());

      if (res?.status === 200) {
        const list = res?.results?.map((i)=>{
          return {
            ...i,
            label:i?.name,
            value:i?.id
          }
        })
        setSupervisorList(list);
        
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
     
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.floorSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const handleSubmit = async () => {
    const validationResult = await utils?.checkFormError(
      form,
      errorSchema.floorSchema
    );


    if (validationResult === true) {
      setIsLoading(true);
      try {
        if (props?.addressId) {
          const res = await updateMasterFloor({
            payload: form,
            id: props?.addressId,
          });

          if (res.status === 200) {
            setIsLoading(false);
            toast.success(res.message);
            props?.closeModal();
            props?.callback();
          } else {
            toast.error(res.error);
          }
        } else {
          const res = await createMasterFloor(form);

          if (res.status === 201) {
            setIsLoading(false);
            toast.success(res.message);
            props?.closeModal();
            props?.callback();
          } else {
            toast.error(res.error);
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const objectBid = {
    ...props,
    onSubmit: handleSubmit,
    disabled: isLoading || props?.eventView,
    isLoadding: isLoading,
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    }
  };

  return (
    <>
      <CommonModal {...objectBid}>
        <div className="_plcMod_body" style={{ padding: "20px" }}>
          <div className="flxInr">
            <div className="singleDiv">
              <CommonInput
                type="text"
                label="Name"
                placeholder="Enter Name"
                name="name"
                value={form?.name}
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                focus={!!formError?.name}
                error={formError.name}
                ref={nameRef}
                onKeyDown={(e) => handleKey(e, startRef)}
                disabled={props?.eventView}
              />
            </div>
            <div className="singleDiv">
              <CustomSelect
                label="Supervisor"
                name="supervisor"
                placeholder="Select Supervisor"
                onSelect={(data) => {
                  handleOnChange("supervisor", data.value);
                }}
                value={supervisorList?.length?supervisorList?.find((f)=>f?.value==form?.supervisor):{label:"",value:""}}
                options={supervisorList}
                focus={!!formError?.supervisor}
                error={formError.supervisor}
                ref={startRef}
                onEnterSelect={() => handleSubmit()}
              
              />
            </div>
          </div>
        </div>
      </CommonModal>
      <div className="offBack_drop"></div>
    </>
  );
};

export default AddFloorModal;
